// app-ui/src/components/canvas/NodeActionsPopup.tsx
import React from 'react';

export interface NodeAction {
    id: string;
    label: string;
    onClick: () => void;
    className?: string;
    show?: boolean;
}

interface NodeActionsPopupProps {
    isOpen: boolean;
    position: { x: number; y: number };
    actions: NodeAction[];
    onClose: () => void;
}

const NodeActionsPopup: React.FC<NodeActionsPopupProps> = ({ 
    isOpen, 
    position, 
    actions, 
    onClose 
}) => {
    if (!isOpen) return null;

    // Filter actions that should be shown
    const visibleActions = actions.filter(action => action.show !== false);

    if (visibleActions.length === 0) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 z-[9998]"
                onClick={onClose}
            />
            
            {/* Popup */}
            <div
                className="fixed z-[9999] bg-gray-800 rounded-lg shadow-xl border border-gray-700 min-w-[200px] py-2"
                style={{
                    left: `${position.x}px`,
                    top: `${position.y}px`,
                    transform: 'translateY(-50%)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {visibleActions.map((action) => (
                    <button
                        key={action.id}
                        onClick={() => {
                            action.onClick();
                            onClose();
                        }}
                        className={`
                            w-full text-left px-4 py-2 text-sm
                            hover:bg-gray-700 transition-colors
                            ${action.className || 'text-gray-200'}
                        `}
                    >
                        {action.label}
                    </button>
                ))}
            </div>
        </>
    );
};

export default NodeActionsPopup;

